import React, { useState, useEffect } from "react";
import Page from "@atlaskit/page";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import Tabs, { Tab, TabList, TabPanel } from "@atlaskit/tabs";
import ConditionsPage from "./tabs/conditionsTab/ConditionsPage";
import ActionMenu from "./menu/ActionMenu";
import GetHelpExtensions from "./extension/GetHelpExtensions";
import ActionStatusToggle from "./ActionStatusToggle";
import ActionExecutionLog from "../../../executionlog/ActionExecutionLog";
import ShowFullScopeVariablePathExtension from "./extension/ShowFullScopeVariablePathExtension";
import { getExecutionLog } from "../../../../redux/actions/logActions";
import { toggleLoading } from "../../../../redux/actions/messageActions";
import ScriptEditor from "./tabs/variablesTab/ScriptVars/ScriptEditor";
import TestScriptButton from "./tabs/variablesTab/ScriptVars/TestScriptButton";
import { Box, Stack } from "@atlaskit/primitives";
import ScriptVariableOptions from "./tabs/variablesTab/ScriptVars/ScriptVariableOptions";

const ScriptActionPage = () => {
  const flow = useSelector((state) => state.integration.flow);
  const { sectionId } = useParams();
  const [currentAction, setCurrentAction] = useState(null);
  const [script, setScript] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    if (flow.actions) {
      const action = flow.actions.find((a) => a.id === sectionId);
      if (action) {
        setScript(action?.script || "");
        setCurrentAction(action);
        dispatch(getExecutionLog(flow.id, null, null, null, action?.id));
        dispatch(toggleLoading(true, "Loading..."));
      }
    }
  }, [sectionId, flow, dispatch]);

  const updateScript = (value) => {
    if (currentAction) {
      currentAction.script = value;
      setScript(value);
    }
  };

  if (!flow.actions) return <div>Loading...</div>;

  return (
    <Page>
      <Tabs>
        <TabList>
          <Tab>Script</Tab>
          <Tab>Conditions</Tab>
          <Tab>Log</Tab>
          <div className="ihub-actionmenu-action">
            <TestScriptButton action={currentAction} scriptItem={{ name: "result", script: script }} appearance="subtle" />
            <GetHelpExtensions />
            <ShowFullScopeVariablePathExtension flowId={flow.id} action={currentAction} />
            <ActionMenu action={currentAction} />
            <ActionStatusToggle action={currentAction} flow={flow} />
          </div>
        </TabList>
        <TabPanel>
          <Stack>
            <Box>
              <ScriptVariableOptions scriptedVariable={currentAction} />
              <ScriptEditor script={script} onChange={updateScript} />
            </Box>
          </Stack>
        </TabPanel>
        <TabPanel>
          <div className="ihub-log-tab-warpper">
            <ConditionsPage action={currentAction} flow={flow} />
          </div>
        </TabPanel>
        <TabPanel>
          <div className="ihub-log-tab-warpper">
            <ActionExecutionLog flow={flow} action={currentAction} />
          </div>
        </TabPanel>
      </Tabs>
    </Page>
  );
};

export default ScriptActionPage;
